export default {"src":"/_next/static/media/credit_card.6aa3f880.svg","height":22,"width":134,"blurWidth":0,"blurHeight":0};